(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

      this.updateLayout = this.updateLayout.bind(this);
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header')
        || document.querySelector('.section-header');
      this.announcement = document.querySelector(
        '.announcement-bar-section'
      );
      this.isHomepage = this.dataset.festauraHome === 'true';

      if (!this.header) return;

      this.header.classList.toggle(
        'festaura-header-home',
        this.isHomepage
      );

      if (!this.isHomepage) {
        this.header.classList.add('festaura-header-light');
      }

      this.resizeObserver = typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(this.updateLayout)
        : null;

      this.resizeObserver?.observe(this.header);

      if (this.announcement) {
        this.resizeObserver?.observe(this.announcement);
      }

      window.addEventListener(
        'scroll',
        this.updateLayout,
        { passive: true }
      );
      window.addEventListener('resize', this.updateLayout);
      document.addEventListener(
        'shopify:section:load',
        this.handleSectionLoad
      );

      if (document.readyState === 'loading') {
        document.addEventListener(
          'DOMContentLoaded',
          this.updateLayout,
          { once: true }
        );
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(this.updateLayout);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.updateLayout);
      window.removeEventListener('resize', this.updateLayout);
      document.removeEventListener(
        'shopify:section:load',
        this.handleSectionLoad
      );
      this.resizeObserver?.disconnect();

      this.header?.classList.remove(
        'festaura-header-fixed',
        'festaura-header-light',
        'festaura-header-home'
      );

      document.documentElement.classList.remove(
        'festaura-light-header-active'
      );
      document.documentElement.style.removeProperty(
        '--festaura-announcement-height'
      );
      document.documentElement.style.removeProperty(
        '--festaura-fixed-header-height'
      );
    }

    handleSectionLoad() {
      this.announcement = document.querySelector(
        '.announcement-bar-section'
      );
      requestAnimationFrame(this.updateLayout);
    }

    updateLayout() {
      if (!this.header) return;

      const announcementHeight = this.announcement
        ? Math.max(
            0,
            Math.round(
              this.announcement.getBoundingClientRect().height
            )
          )
        : 0;

      const headerHeight = Math.max(
        0,
        Math.round(this.header.getBoundingClientRect().height)
      );

      document.documentElement.style.setProperty(
        '--festaura-announcement-height',
        `${announcementHeight}px`
      );
      document.documentElement.style.setProperty(
        '--festaura-fixed-header-height',
        `${headerHeight}px`
      );

      if (!this.isHomepage) {
        this.header.classList.remove('festaura-header-fixed');
        this.header.classList.add('festaura-header-light');
        document.documentElement.classList.remove(
          'festaura-light-header-active'
        );
        return;
      }

      const hero = document.querySelector('festaura-hero');
      const shouldFix = window.scrollY >= Math.max(
        announcementHeight,
        1
      );

      const heroBottom = hero
        ? hero.getBoundingClientRect().bottom
        : Number.POSITIVE_INFINITY;

      const shouldUseLightMode = Boolean(
        hero
        && shouldFix
        && heroBottom <= Math.max(headerHeight, 1)
      );

      this.header.classList.toggle(
        'festaura-header-fixed',
        shouldFix
      );
      this.header.classList.toggle(
        'festaura-header-light',
        shouldUseLightMode
      );
      document.documentElement.classList.toggle(
        'festaura-light-header-active',
        shouldUseLightMode
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures
        || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal
        || this.header.querySelector('details-modal');

      this.searchModal?.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
